import { ListChecks } from 'lucide-react';

import { TrackingEvents } from '../../../../analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { cn } from '@/helpers/shadCnUtils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/new/components/shadcn/tooltip';

export const ShowFactsIcon = ({
  showFacts,
  setShowFacts,
}: {
  showFacts: boolean;
  setShowFacts: (showFacts: boolean) => void;
}) => {
  return (
    <TooltipProvider delayDuration={0} skipDelayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            onClick={() => {
              setShowFacts(!showFacts);
              trackCustomEvent(TrackingEvents.ShowAllFactsInDocViewer);
            }}
            className={cn(
              'group flex cursor-pointer items-center rounded-lg border-2 border-blue-300 bg-blue-50 px-1.5 py-1 text-blue-600 shadow-xl transition-all hover:border-blue-400 hover:bg-blue-100',
              showFacts && 'border-blue-400 bg-blue-400 text-white hover:border-blue-400 hover:bg-blue-400',
            )}
          >
            <ListChecks className="h-4 w-4 transition-transform group-hover:scale-110" />
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>Show all facts in document</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
